import React, { useContext } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ThemeContext } from '../../Theme'
import useFetchData from '../../hooks/use-fetch-data'
import { PassionateContainer } from './PassionateWrapper'
import './style.css'
import { Container } from 'react-bootstrap'

function Passionate() {
    const { theme } = useContext(ThemeContext);
    const { data } = useFetchData();

  return (
    <PassionateContainer>
        {
            data.map(item => item.id === 7 ?
            <div className='passionate-wrapper' style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundAttachment: 'fixed', backgroundImage: `url(${item.acf.background_image})` }}>
                <Container>
                  <div 
                  
                  className='passionate-container__background'>
                    <motion.p 
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y:0, transition: { delay: 0.5, duration: 0.5}}}
                    viewport={{ once: false, amount: 1}}
                    style={theme === 'light-theme' ? { color: 'var(--text-primary-light)'} : {color: 'var(--text-primary-dark)'} }>{item.acf.headline_text}</motion.p>
                    <motion.h2 
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0,  transition: { ease: [0.075, 0.82, 0.165, 1], delay: 0.2, duration: 0.8 }}}
                    viewport={{ once: false, amount: 0.5}}
                    style={theme === 'light-theme' ? { color: 'var(--text-primary-light)'} : {color: 'var(--text-primary-dark)'} } key={item.id}>{item.acf.main_heading_text}</motion.h2>
                    <Link className="cta" to={item.acf.cta_link}>{item.acf.cta_text}</Link>
                  </div>
                </Container>
               </div>
            : null
            )
        }
    </PassionateContainer>
  )
}

export default Passionate
